<template>
  <div>
    <form class="clearfix" @submit.prevent="getDrafts(1)">
      <ul class="filter_form clearfix">
        <li class="filter_form__items">
          <label class="filter_form__label" for="type-filter">{{
            $t('pages.messageDrafts.messageFilters.type')
          }}</label>
          <BaseSelect
            v-model="messageParams.type"
            :options="messageTypes"
            :reduce="(option) => option.code"
            id="type-filter"
            clearable
          />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label">{{
            $t('pages.messageDrafts.messageFilters.sender')
          }}</label>
          <input v-model="messageParams.sender" type="text" class="form-control" />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label">{{
            $t('pages.messageDrafts.messageFilters.recipient')
          }}</label>
          <input v-model="messageParams.recipient" type="text" class="form-control" />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label">{{
            $t('pages.messageDrafts.messageFilters.subject')
          }}</label>
          <input v-model="messageParams.subject" type="text" class="form-control" />
        </li>

        <li class="filter_form__items filter_form__items--full">
          <button
            :disabled="loadingMessages"
            type="submit"
            class="btn btn-feat btn-mobile-full pull-right"
          >
            {{ $t('actions.updateResults') }}
          </button>
        </li>
      </ul>
    </form>

    <div v-if="$hasPermission(['msg_1'])" class="helpers">
      <span class="helpers__title">{{ $t('common.actions') }}:</span>
      <a href="#" class="btn btn-regular btn-mobile-full" @click.prevent="createDraft"
        ><i class="icon-edit" style="margin-right: 4px;"></i>
        {{ $t('pages.messageDrafts.actions.createNew') }}</a
      >
    </div>

    <BaseTable
      :headers="messageTableHeaders"
      :items="messages"
      :pagination="messagePagination"
      :loading="loadingMessages"
      :on-row-click="viewMessage"
      enable-sorting
      @update:page="getDrafts"
      @update:sorting="setOrderBy"
    >
      <template #item.recipient="{ item }">
        <MessageRecipients :recipients="item.recipient" />
      </template>
      <template #item.lastUpdateDate="{ item }">
        {{ $formatDate(item.lastUpdateDate, 'yyyy-MM-dd HH:mm') }}
      </template>
      <template #item.actions="{ item }">
        <div class="text-right">
          <i class="icon-trash clickable" @click.stop="confirmDraftDeletion(item)"></i>
        </div>
      </template>
    </BaseTable>

    <ConfirmationModal
      :is-open="confirmationModal"
      :title="$t('pages.messageDrafts.labels.confirmDraftDelete')"
      :body="messageToDelete.subject"
      @cancel="confirmationModal = false"
      @confirm="deleteDraft"
    />
  </div>
</template>

<script>
import BaseSelect from './base/BaseSelect';
import messageService from '../services/message.service';
import ConfirmationModal from './ConfirmationModal';
import MessageRecipients from './MessageRecipients';
import BaseTable from './base/BaseTable';
import { getCurrentPageAfterDeleting } from '@/util/pagination';

export default {
  name: 'MessagesDrafts',

  components: { BaseTable, MessageRecipients, ConfirmationModal, BaseSelect },

  props: {
    messageTypes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loadingMessages: false,
      messages: [],
      messagePagination: {},
      messageParams: {},
      confirmationModal: false,
      messageToDelete: {},
    };
  },

  computed: {
    messageTableHeaders() {
      const translationKey = 'pages.messageDrafts.messageTable.headers';
      return [
        { text: this.$t(`${translationKey}.type`), value: 'type.name' },
        { text: this.$t(`${translationKey}.sender`), value: 'sender' },
        { text: this.$t(`${translationKey}.recipient`), value: 'recipient' },
        { text: this.$t(`${translationKey}.subject`), value: 'subject' },
        { text: this.$t(`${translationKey}.lastUpdateDate`), value: 'lastUpdateDate' },
        { text: '', value: 'actions' },
      ];
    },
  },

  created() {
    this.getDrafts();
  },

  methods: {
    createDraft() {
      messageService.initDraft().then((res) => {
        window.location.href = this.$url(
          `${this.$t('pages.messageDraft.url')}?id=${res.data.messageId}&mode=edit`
        );
      });
    },

    confirmDraftDeletion(message) {
      this.messageToDelete = message;
      this.confirmationModal = true;
    },

    deleteDraft() {
      this.confirmationModal = false;
      this.loadingMessages = true;
      messageService
        .deleteDraft([this.messageToDelete.messageId])
        .then(() => {
          this.getDrafts(getCurrentPageAfterDeleting(this.messagePagination));
        })
        .finally(() => {
          this.loadingMessages = false;
        });
    },

    getDrafts(page = 1) {
      this.loadingMessages = true;
      const params = { ...this.messageParams, page };
      messageService
        .getDraftList(params)
        .then((res) => {
          this.messages = res.data.draftMessage;
          this.messagePagination = {
            page: res.data.page,
            total: res.data.total,
            pageSize: res.data.pageSize,
          };
        })
        .catch(() => {
          this.messages = [];
          this.messagePagination = {};
        })
        .finally(() => {
          this.loadingMessages = false;
        });
    },

    setOrderBy(string) {
      this.$set(this.messageParams, 'orderBy', string);
      this.getDrafts();
    },

    viewMessage(message) {
      window.location.href = this.$url(
        `${this.$t('pages.messageDraft.url')}?id=${message.messageId}`
      );
    },
  },
};
</script>
